import {
  HttpClient,
  HttpErrorResponse,
  HttpEventType,
  HttpHeaders,
  HttpParams,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import { JwtService } from "../@core/services/jwt.service";
import { environment } from "../../environments/environment";
import {Injectable, Injector, NgZone} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import { convertPayloadDatetime } from "../@core/utils/utils.service";
import { convertResponseDatetime } from "../@core/utils/utils.service";
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, filter, finalize, map, switchMap, take } from 'rxjs/operators';
import {jwtDecode} from "jwt-decode";
import {AuthService} from "../@core/services/auth.service";
import {
  AQH_CLS_0,
  AQH_EVE_0, AQH_EVE_1,
  AQH_EVE_10, AQH_EVE_11,
  AQH_EVE_12, AQH_EVE_13,
  AQH_EVE_14, AQH_EVE_15, AQH_EVE_16, AQH_EVE_17, AQH_EVE_18, AQH_EVE_19, AQH_EVE_2, AQH_EVE_20, AQH_EVE_21, AQH_EVE_22, AQH_EVE_23, AQH_EVE_24, AQH_EVE_25, AQH_EVE_26, AQH_EVE_27, AQH_EVE_28, AQH_EVE_29, AQH_EVE_30, AQH_EVE_31, AQH_EVE_32, AQH_EVE_33, AQH_EVE_34, AQH_EVE_35, AQH_EVE_3, AQH_EVE_4, AQH_EVE_5, AQH_EVE_6, AQH_EVE_7, AQH_EVE_8, AQH_EVE_9,
  AQH_FAM_0,
  AQH_FAM_1, AQH_FAM_2,
  AQH_HOR_0, AQH_HOR_1, AQH_HOR_2, AQH_HOR_3, AQH_HOR_4, AQH_MEM_0, AQH_MEM_1, AQH_MEM_2, AQH_MEM_3, AQH_MEM_4, AQH_MEM_5, AQH_MEM_6, AQH_MEM_7, AQH_STA_0, AQH_STA_1,
  COR_COY_0,
  COR_COY_1,
  COR_COY_2,
  COR_COY_3,
  COR_COY_4, COR_COY_5, COR_COY_6, COR_COY_7, COR_COY_8,
  USM_ENT_0,
  USM_ENT_2,
  USM_ENT_3,
  USM_USR_0,
  USM_USR_1,
  USM_USR_13,
  USM_USR_14,
  USM_USR_16,
  USM_USR_18,
  USM_USR_19,
  USM_USR_22,
  USM_USR_25,
  USM_USR_26, USM_USR_27,
  USM_USR_3,
  USM_USR_34,
  USM_USR_35,
  USM_USR_6
} from "./models/input.module";
import {
  DeleteResponse,
  GetResponse,
  PaginationResponse,
  PostResponse,
  PutResponse
} from "./models/global/response-wrapper.service";
import {
  ApplicationResponse, ApplicationTypeResponse, CandidateCompactResponse, CandidateResponse,
  ClassResponse, CompanyImageResponse,
  CompanyResponse, EventClassRegistrationResponse, EventClassResponse, EventClassSponsorResponse, EventContactResponse, EventContactRoleResponse, EventResponse, EventServiceRegistrationResponse, EventServiceResponse, EventSponsorResponse, EventTypeResponse, FamilyMemberResponse,
  HorseRegistryResponse, HorseResponse,
  InvitationTokenVerificationResponse,
  LoginResponse, MembershipPlanResponse, MembershipResponse, SponsorResponse,
  UserEntityRelationWithoutUserDataResponse,
  UserEntityRelationWithUserDataResponse,
  UserOptionsResponse,
  UserResponse
} from "./models/response.module";
import {Horses} from './services/horses';
export interface EndpointOptions {
  auth?: boolean,
  content_type?: string | null,
  platform?: boolean,
  raiseErrorToast?: boolean,
  useBody?: boolean
}

@Injectable({
  providedIn: 'root',
})
export class EndpointService {
  constructor(private http: HttpClient,
              private jwtService: JwtService,
              private translateService: TranslateService,
              private injector: Injector,
              private zone: NgZone
  ) {}


  private refreshTokenSubject: BehaviorSubject<any | null> = new BehaviorSubject<any | null>(null);
  private refreshTokenInProgress = false;

  refreshToken(): Observable<string> {
    const authService = this.injector.get(AuthService);

    if (this.refreshTokenInProgress) {
      return this.refreshTokenSubject.pipe(
        filter((token) => token !== null),
        take(1)
      );
    }

    this.refreshTokenInProgress = true;
    this.refreshTokenSubject.next(null);

    return authService.refreshToken().pipe(
      switchMap((data) => {
        const newToken = data.access_token;
        this.refreshTokenSubject.next(newToken);
        return of(newToken); // Return the new token
      }),
      catchError((error) => {
        // Handle token refresh error here
        return throwError(error);
      }),
      finalize(() => {
        this.refreshTokenInProgress = false;
      })
    );
  }

  /**
  *
  * Default HTTP functions
  *
  */

  private handleResponse<T>(observable: Observable<T>): Observable<T> {
  return observable.pipe(
    map((res) => {
      if (res) {
        convertResponseDatetime(res);
      }
      return res;
    })
  )};

  private handlePayload(data: any): any {
    if (data) {
      data = convertPayloadDatetime(data);
    }
    return data;
  }

  getDefaultHeaders(auth: boolean = true, content_type: string | null = 'application/json', platform: boolean = false): Observable<HttpHeaders> {
    // Accept-Language
    let headers = new HttpHeaders({
      'Accept-Language': this.translateService.currentLang ? this.translateService.currentLang : 'en',
    });

    // Content-Type
    if (content_type != null) {
      headers = headers.append('Content-Type', content_type);
    }

    // Platform
    if (platform) {
      headers = headers.append('Platform', 'core');
    }

    // Authorization
    if (auth) {
      if (this.jwtService.getAccessToken() == null || this.jwtService.getAccessToken() == undefined || this.jwtService.getAccessToken() == '') {
        throw new Error('No access token found')
      }
      const decodedToken: {[key: string]: string | number} = jwtDecode(this.jwtService.getAccessToken());
      const currentTimestamp = Math.floor(Date.now() / 1000); // Get current Unix timestamp in seconds
      const tokenExpiration = decodedToken["exp"];

      if (tokenExpiration && tokenExpiration < currentTimestamp.toString()) {
        return this.refreshToken().pipe(
          switchMap((newToken) => {
            headers = headers.append('Authorization', 'Bearer ' + newToken);
            return of(headers);
          })
        );
      } else {
        headers = headers.append('Authorization', 'Bearer ' + this.jwtService.getAccessToken());
        return of(headers);
      }
    } else {
      return of(headers);
    }
  }

  // post<R>(url: string, payload: any, auth = true, content_type?: string | null, platform: boolean = false, raiseErrorToast: boolean = true): Observable<R> {
  post<R>(url: string, payload: any, options: EndpointOptions): Observable<R> {
    return this.getDefaultHeaders(options.auth, options.content_type, options.platform).pipe(
      switchMap((headers) => {
        payload = this.handlePayload(payload);
        return this.http.post<R>(url, payload, {headers: headers}).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && options.raiseErrorToast) {
              // this.toastService.errorToast(error.error.asset_id);
            }
            return throwError(error);
          }),
          switchMap((response: R) => {
            return this.handleResponse<R>(of(response));
          })
        );
      })
    );
  }

  put<R>(url: string, payload: any, options: EndpointOptions): Observable<R> {
    return this.getDefaultHeaders(options.auth, options.content_type, options.platform).pipe(
      switchMap((headers) => {
        payload = this.handlePayload(payload);
        return this.http.put<R>(url, payload, {headers: headers}).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && options.raiseErrorToast) {
              // this.toastService.errorToast(error.error.asset_id);
            }
            return throwError(error);
          }),
          switchMap((response: R) => {
            return this.handleResponse<R>(of(response));
          })
        );
      })
    );
  }

  patch<R>(url: string, payload: any, options: EndpointOptions): Observable<R> {
    return this.getDefaultHeaders(options.auth, options.content_type, options.platform).pipe(
      switchMap((headers) => {
        payload = this.handlePayload(payload);
        return this.http.patch<R>(url, payload, {headers: headers}).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && options.raiseErrorToast) {
              // this.toastService.errorToast(error.error.asset_id);
            }
            return throwError(error);
          }),
          switchMap((response: R) => {
            return this.handleResponse<R>(of(response));
          })
        );
      })
    );
  }

  get<R>(url: string, queryParams: { [key: string]: any } | undefined, options: EndpointOptions): Observable<R> {
    return this.getDefaultHeaders(options.auth, options.content_type, options.platform).pipe(
      switchMap((headers) => {
        queryParams = this.handlePayload(queryParams);
        let httpParams = new HttpParams();
        if (queryParams) {
          Object.keys(queryParams).forEach(key => {
            const value = queryParams?.[key];
            if (value !== undefined && value !== null) {
              httpParams = httpParams.set(key, value);
            }
          });
        }

        return this.http.get<R>(url, { headers: headers, params: httpParams }).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && options.raiseErrorToast) {
              // this.toastService.errorToast(error.error.asset_id);
            }
            return throwError(error);
          }),
          switchMap((response: R) => {
            return this.handleResponse<R>(of(response));
          })
        );
      })
    );
  }

  delete<R>(url: string, queryParams: { [key: string]: any } | undefined, options: EndpointOptions): Observable<R> {
    return this.getDefaultHeaders(options.auth, options.content_type, options.platform).pipe(
      switchMap((headers) => {
        queryParams = this.handlePayload(queryParams);

        // Use body or query params based on useBody option
        if (options.useBody) {
          // Send payload as request body
          return this.http.delete<R>(url, { headers: headers, body: queryParams }).pipe(
            catchError((error: any) => {
              if (error instanceof HttpErrorResponse && options.raiseErrorToast) {
                // this.toastService.errorToast(error.error.asset_id);
              }
              return throwError(error);
            }),
            switchMap((response: R) => {
              return this.handleResponse<R>(of(response));
            })
          );
        } else {
          // Send payload as query params (default)
          let httpParams = new HttpParams();
          if (queryParams) {
            Object.keys(queryParams).forEach(key => {
              const value = queryParams?.[key];
              if (value !== undefined && value !== null) {
                httpParams = httpParams.set(key, value);
              }
            });
          }
          return this.http.delete<R>(url, { headers: headers, params: httpParams }).pipe(
            catchError((error: any) => {
              if (error instanceof HttpErrorResponse && options.raiseErrorToast) {
                // this.toastService.errorToast(error.error.asset_id);
              }
              return throwError(error);
            }),
            switchMap((response: R) => {
              return this.handleResponse<R>(of(response));
            })
          );
        }
      })
    );
  }


  /**
  *
  * Endpoint definitions
   * USM
   * Users
  *
  */

  usm_aut_0(payload: USM_USR_0, raiseErrorToast: boolean = true): Observable<LoginResponse> {
    let options: EndpointOptions = {
      auth: false,
      content_type: null,
      platform: true,
      raiseErrorToast: raiseErrorToast
    }
    return this.post(environment.coreApiUrl + 'users/login', payload, options)
  }

  usm_aut_1(raiseErrorToast: boolean = true): Observable<LoginResponse> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': this.translateService.currentLang,
      'Authorization': 'Bearer ' + this.jwtService.getRefreshToken(),
      'Platform': 'core'
    })
    let options = {headers: headers}
    return this.http.post<LoginResponse>(environment.coreApiUrl + 'users/refresh-token', {}, options).pipe(
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse && raiseErrorToast) {
          // this.toastService.errorToast(error.error.asset_id);
        }
        return throwError(error);
      }),
    );
  }

  usm_usr_1(raiseErrorToast: boolean = true): Observable<GetResponse<UserResponse>>  {
    return this.get(environment.coreApiUrl + 'users/', undefined, {raiseErrorToast: raiseErrorToast})
  }

  usm_usr_3(payload: USM_USR_3, raiseErrorToast: boolean = true): Observable<PutResponse<UserResponse>> {
    return this.put(environment.coreApiUrl + 'users/', payload, {raiseErrorToast: raiseErrorToast})
  }

  usm_usr_6(payload: USM_USR_6, raiseErrorToast: boolean = true): Observable<PostResponse<UserEntityRelationWithUserDataResponse>> {
    return this.post(environment.coreApiUrl + 'users/invite/to-entity', payload, {raiseErrorToast: raiseErrorToast})
  }

  usm_usr_13(payload: USM_USR_13, raiseErrorToast: boolean = true): Observable<GetResponse<null>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.post(environment.coreApiUrl + 'users/reset-password/initiate', payload, options)
  }

  usm_usr_14(payload: USM_USR_14, raiseErrorToast: boolean = true): Observable<PostResponse<null>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.post(environment.coreApiUrl + 'users/reset-password/token', payload, options)
  }

  usm_usr_16(payload: USM_USR_16, raiseErrorToast: boolean = true): Observable<PutResponse<UserResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        // Initialize HttpParams with company_id
        let httpParams = new HttpParams()
        // FormData instance
        let formData = new FormData();
        formData.append('image', payload.image);

        // Update headers to be compatible with FormData
        const options = { headers: headers, params: httpParams };

        return this.http.put<PutResponse<UserResponse>>(environment.coreApiUrl + 'users/profile-image', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  usm_usr_21(payload: any, raiseErrorToast: boolean = true): Observable<GetResponse<UserOptionsResponse>> {
    return this.get(environment.coreApiUrl + 'users/options', payload, {raiseErrorToast: raiseErrorToast})
  }

  usm_usr_18(payload: USM_USR_18, raiseErrorToast: boolean = true): Observable<PostResponse<null>> {
    return this.post(environment.coreApiUrl + 'users/reset-password', payload, {raiseErrorToast: raiseErrorToast})
  }

  usm_usr_19(payload: USM_USR_19, raiseErrorToast: boolean = true): Observable<LoginResponse> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.post(environment.coreApiUrl + 'users/register/invitation-token', payload, options)
  }

  usm_usr_22(payload: USM_USR_22, raiseErrorToast: boolean = true): Observable<PutResponse<UserOptionsResponse>> {
    return this.put(environment.coreApiUrl + 'users/options', payload, {raiseErrorToast: raiseErrorToast})
  }

  usm_usr_25(payload: USM_USR_25, raiseErrorToast: boolean = true): Observable<PostResponse<InvitationTokenVerificationResponse>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.post(environment.coreApiUrl + 'users/register/invitation-token/verify', payload, options)
  }

  usm_usr_34(payload: USM_USR_34, raiseErrorToast: boolean = true): Observable<PostResponse<UserResponse>> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.post(environment.coreApiUrl + 'users/register/public', payload, options)
  }

  usm_usr_35(payload: USM_USR_35, raiseErrorToast: boolean = true): Observable<LoginResponse> {
    let options: EndpointOptions = {
      auth: false,
      raiseErrorToast: raiseErrorToast
    }
    return this.post(environment.coreApiUrl + 'users/verify-email', payload, options)
  }

  usm_ent_0(payload: USM_ENT_0, raiseErrorToast: boolean = true): Observable<GetResponse<UserEntityRelationWithoutUserDataResponse[]>> {
    return this.get(environment.coreApiUrl + 'users/access', payload, {raiseErrorToast: raiseErrorToast})
  }

  usm_ent_2(payload: USM_ENT_2, raiseErrorToast: boolean = true): Observable<PutResponse<UserEntityRelationWithUserDataResponse>> {
    return this.patch(environment.coreApiUrl + 'users/access', payload, {raiseErrorToast: raiseErrorToast})
  }

  usm_ent_3(payload: USM_ENT_3, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'users/access', payload, {raiseErrorToast: raiseErrorToast})
  }
  // usm_usr_2(payload: USM_USR_2, raiseErrorToast: boolean = true): Observable<PostResponse<UserResponse>> {
  //   return this.post(environment.coreApiUrl + 'users/', payload, {raiseErrorToast: raiseErrorToast})
  // }
  //
  // usm_usr_3(raiseErrorToast: boolean = true): Observable<PostResponse<UserResponse>>  {
  //   return this.get(environment.coreApiUrl + 'users/', undefined, {raiseErrorToast: raiseErrorToast})
  // }


  cor_coy_0(payload: COR_COY_0, raiseErrorToast: boolean = true): Observable<GetResponse<CompanyResponse>> {
    return this.get(environment.coreApiUrl + 'companies/', payload, {raiseErrorToast: raiseErrorToast})
  }

  cor_coy_1(payload: COR_COY_1, raiseErrorToast: boolean = true): Observable<PostResponse<CompanyResponse>> {
    return this.post(environment.coreApiUrl + 'companies/', payload, {raiseErrorToast: raiseErrorToast})
  }

  cor_coy_2(payload: COR_COY_2, raiseErrorToast: boolean = true): Observable<PutResponse<CompanyResponse>> {
    return this.put(environment.coreApiUrl + 'companies/', payload, {raiseErrorToast: raiseErrorToast})
  }

  cor_coy_3(payload: COR_COY_3, raiseErrorToast: boolean = true): Observable<GetResponse<UserEntityRelationWithUserDataResponse[]>> {
    return this.get(environment.coreApiUrl + 'companies/employees', payload, {raiseErrorToast: raiseErrorToast})
  }

  cor_coy_4(payload: COR_COY_4, raiseErrorToast: boolean = true): Observable<PaginationResponse<CompanyResponse[]>> {
    return this.get(environment.coreApiUrl + 'companies/all', payload, {raiseErrorToast: raiseErrorToast})
  }

  cor_coy_5(payload: COR_COY_5, raiseErrorToast: boolean = true): Observable<GetResponse<CompanyImageResponse[]>> {
    return this.get(environment.coreApiUrl + 'companies/images', payload, {raiseErrorToast: raiseErrorToast})
  }

  cor_coy_6(payload: COR_COY_6, raiseErrorToast: boolean = true): Observable<PostResponse<CompanyImageResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        // Initialize HttpParams with company_id

        let httpParams = new HttpParams()
          .set('company_id', payload.company_id)

        // FormData instance
        let formData = new FormData();
        formData.append('image', payload.image);
        formData.append('company_id', payload.company_id);

        // Update headers to be compatible with FormData
        const options = { headers: headers, params: httpParams };

        return this.http.post<PostResponse<CompanyImageResponse>>(environment.coreApiUrl + '/companies/images', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  cor_coy_7(payload: COR_COY_7, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + '/companies/images', payload, {raiseErrorToast: raiseErrorToast})
  }

  cor_coy_8(payload: COR_COY_8, raiseErrorToast: boolean = true): Observable<PutResponse<CompanyResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        // Initialize HttpParams with company_id
        let httpParams = new HttpParams()
          .set('company_id', payload.company_id)
          .set('image_type', payload.image_type);

        // FormData instance
        let formData = new FormData();
        formData.append('company_id', payload.company_id);
        formData.append('image', payload.image);
        formData.append('image_type', payload.image_type);

        // Update headers to be compatible with FormData
        const options = { headers: headers, params: httpParams };

        return this.http.put<PutResponse<CompanyResponse>>(environment.coreApiUrl + 'companies/files', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  aqh_hor_0(payload: AQH_HOR_0, raiseErrorToast: boolean = true): Observable<GetResponse<HorseResponse[]>> {
    return this.get(environment.coreApiUrl + 'horses/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_hor_1(payload: AQH_HOR_1, raiseErrorToast: boolean = true): Observable<PostResponse<HorseResponse>> {
    return this.post(environment.coreApiUrl + 'horses/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_hor_2(payload: AQH_HOR_2, raiseErrorToast: boolean = true): Observable<PutResponse<HorseResponse>> {
    return this.put(environment.coreApiUrl + 'horses/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_hor_3(payload: AQH_HOR_3, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'horses/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_hor_4(payload: AQH_HOR_4, raiseErrorToast: boolean = true): Observable<PutResponse<HorseResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        // Initialize HttpParams with company_id

        let httpParams = new HttpParams()
          .set('horse_id', payload.horse_id.toString())
          .set('image_type', payload.image_type);

        // FormData instance
        let formData = new FormData();
        formData.append('image', payload.image);
        formData.append('image_type', payload.image_type);
        formData.append('horse_id', payload.horse_id.toString());

        // Update headers to be compatible with FormData
        const options = { headers: headers, params: httpParams };

        return this.http.put<PutResponse<HorseResponse>>(environment.coreApiUrl + 'horses/images', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  aqh_mem_0(payload: AQH_MEM_0, raiseErrorToast: boolean = true): Observable<GetResponse<MembershipResponse[]>> {
    return this.get(environment.coreApiUrl + 'memberships/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_mem_1(payload: AQH_MEM_1, raiseErrorToast: boolean = true): Observable<PostResponse<MembershipResponse>> {
    return this.post(environment.coreApiUrl + 'memberships/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_mem_2(payload: AQH_MEM_2, raiseErrorToast: boolean = true): Observable<PutResponse<MembershipResponse>> {
    return this.put(environment.coreApiUrl + 'memberships/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_mem_3(payload: AQH_MEM_3, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'memberships/', payload, {raiseErrorToast: raiseErrorToast, useBody: true})
  }

  aqh_mem_4(payload: AQH_MEM_4, raiseErrorToast: boolean = true): Observable<GetResponse<MembershipPlanResponse[]>> {
    return this.get(environment.coreApiUrl + 'memberships/plans', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_mem_5(payload: AQH_MEM_5, raiseErrorToast: boolean = true): Observable<PostResponse<MembershipPlanResponse>> {
    return this.post(environment.coreApiUrl + 'memberships/plans', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_mem_6(payload: AQH_MEM_6, raiseErrorToast: boolean = true): Observable<PutResponse<MembershipPlanResponse>> {
    return this.put(environment.coreApiUrl + 'memberships/plans', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_mem_7(payload: AQH_MEM_7, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'memberships/plans', payload, {raiseErrorToast: raiseErrorToast, useBody: true})
  }

  aqh_fam_0(payload: AQH_FAM_0, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'families/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_fam_1(payload: AQH_FAM_1, raiseErrorToast: boolean = true): Observable<PostResponse<FamilyMemberResponse>> {
    return this.post(environment.coreApiUrl + 'families/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_fam_2(payload: AQH_FAM_2, raiseErrorToast: boolean = true): Observable<PostResponse<FamilyMemberResponse>> {
    return this.post(environment.coreApiUrl + 'families/child', payload, {raiseErrorToast: raiseErrorToast})
  }


  aqh_eve_0(payload: AQH_EVE_0, raiseErrorToast: boolean = true): Observable<PaginationResponse<EventResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_1(payload: AQH_EVE_1, raiseErrorToast: boolean = true): Observable<PostResponse<EventResponse>> {
    return this.post(environment.coreApiUrl + 'events/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_2(payload: AQH_EVE_2, raiseErrorToast: boolean = true): Observable<PutResponse<EventResponse>> {
    return this.put(environment.coreApiUrl + 'events/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_3(payload: AQH_EVE_3, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_4(payload: AQH_EVE_4, raiseErrorToast: boolean = true): Observable<GetResponse<EventTypeResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/event-types', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_5(payload: AQH_EVE_5, raiseErrorToast: boolean = true): Observable<PutResponse<EventResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        // Initialize HttpParams with company_id

        let httpParams = new HttpParams()
          .set('company_id', payload.company_id)
          .set('event_id', payload.event_id.toString())
          .set('image_type', payload.image_type);

        // FormData instance
        let formData = new FormData();
        formData.append('company_id', payload.company_id);
        formData.append('image', payload.image);
        formData.append('image_type', payload.image_type);
        formData.append('event_id', payload.event_id.toString());

        // Update headers to be compatible with FormData
        const options = { headers: headers, params: httpParams };

        return this.http.put<PutResponse<EventResponse>>(environment.coreApiUrl + 'events/files', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  aqh_eve_6(payload: AQH_EVE_6, raiseErrorToast: boolean = true): Observable<GetResponse<EventClassResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/event-classes', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_7(payload: AQH_EVE_7, raiseErrorToast: boolean = true): Observable<PostResponse<EventClassResponse>> {
    return this.post(environment.coreApiUrl + 'events/event-classes', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_8(payload: AQH_EVE_8, raiseErrorToast: boolean = true): Observable<PutResponse<EventClassResponse>> {
    return this.put(environment.coreApiUrl + 'events/event-classes', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_9(payload: AQH_EVE_9, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/event-classes', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_10(payload: AQH_EVE_10, raiseErrorToast: boolean = true): Observable<PutResponse<EventClassResponse>> {
    return this.put(environment.coreApiUrl + 'events/event-classes/status', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_11(payload: AQH_EVE_11, raiseErrorToast: boolean = true): Observable<GetResponse<EventServiceResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/event-services', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_12(payload: AQH_EVE_12, raiseErrorToast: boolean = true): Observable<PostResponse<EventServiceResponse>> {
    return this.post(environment.coreApiUrl + 'events/event-services', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_13(payload: AQH_EVE_13, raiseErrorToast: boolean = true): Observable<PutResponse<EventServiceResponse>> {
    return this.put(environment.coreApiUrl + 'events/event-services', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_14(payload: AQH_EVE_14, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/event-services', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_15(payload: AQH_EVE_15, raiseErrorToast: boolean = true): Observable<PostResponse<SponsorResponse>> {
    return this.post(environment.coreApiUrl + 'events/sponsors', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_16(payload: AQH_EVE_16, raiseErrorToast: boolean = true): Observable<PostResponse<EventSponsorResponse>> {
    return this.post(environment.coreApiUrl + 'events/sponsors/event', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_17(payload: AQH_EVE_17, raiseErrorToast: boolean = true): Observable<PostResponse<EventClassSponsorResponse>> {
    return this.post(environment.coreApiUrl + 'events/sponsors/event-class', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_18(payload: AQH_EVE_18, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/sponsors/event', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_19(payload: AQH_EVE_19, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/sponsors/event-class', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_20(payload: AQH_EVE_20, raiseErrorToast: boolean = true): Observable<PutResponse<SponsorResponse>> {
    return this.getDefaultHeaders(true, null).pipe(
      switchMap((headers) => {
        let httpParams = new HttpParams()
          .set('sponsor_id', payload.sponsor_id.toString())
          .set('image_type', payload.image_type);

        let formData = new FormData();
        formData.append('sponsor_id', payload.sponsor_id.toString());
        formData.append('image', payload.image);
        formData.append('image_type', payload.image_type);

        const options = { headers: headers, params: httpParams };

        return this.http.put<PutResponse<SponsorResponse>>(environment.coreApiUrl + 'events/sponsors/files', formData, options).pipe(
          catchError((error: any) => {
            if (error instanceof HttpErrorResponse && raiseErrorToast) {
            }
            return throwError(error);
          }),
        );
      })
    );
  }

  aqh_eve_21(payload: AQH_EVE_21, raiseErrorToast: boolean = true): Observable<GetResponse<EventSponsorResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/sponsors/event', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_22(payload: AQH_EVE_22, raiseErrorToast: boolean = true): Observable<GetResponse<EventClassSponsorResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/sponsors/event-class', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_23(payload: AQH_EVE_23, raiseErrorToast: boolean = true): Observable<PutResponse<SponsorResponse>> {
    return this.put(environment.coreApiUrl + 'events/sponsors', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_24(payload: AQH_EVE_24, raiseErrorToast: boolean = true): Observable<GetResponse<EventContactResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/contacts', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_25(payload: AQH_EVE_25, raiseErrorToast: boolean = true): Observable<PostResponse<EventContactResponse>> {
    return this.post(environment.coreApiUrl + 'events/contacts', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_26(payload: AQH_EVE_26, raiseErrorToast: boolean = true): Observable<PutResponse<EventContactResponse>> {
    return this.put(environment.coreApiUrl + 'events/contacts', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_27(payload: AQH_EVE_27, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/contacts', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_28(payload: AQH_EVE_28, raiseErrorToast: boolean = true): Observable<GetResponse<EventContactRoleResponse[]>> {
    return this.get(environment.coreApiUrl + 'events/contact-roles', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_29(payload: AQH_EVE_29, raiseErrorToast: boolean = true): Observable<PostResponse<EventClassRegistrationResponse>> {
    return this.post(environment.coreApiUrl + 'events/registrations/class', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_30(payload: AQH_EVE_30, raiseErrorToast: boolean = true): Observable<PostResponse<EventServiceRegistrationResponse>> {
    return this.post(environment.coreApiUrl + 'events/registrations/service', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_31(payload: AQH_EVE_31, raiseErrorToast: boolean = true): Observable<GetResponse<{class_registrations: EventClassRegistrationResponse[], service_registrations: EventServiceRegistrationResponse[]}>> {
    return this.get(environment.coreApiUrl + 'events/registrations', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_32(payload: AQH_EVE_32, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/registrations/class', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_33(payload: AQH_EVE_33, raiseErrorToast: boolean = true): Observable<DeleteResponse> {
    return this.delete(environment.coreApiUrl + 'events/registrations/service', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_34(payload: AQH_EVE_34, raiseErrorToast: boolean = true): Observable<PutResponse<any>> {
    return this.put(environment.coreApiUrl + 'events/registrations/class', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_eve_35(payload: AQH_EVE_35, raiseErrorToast: boolean = true): Observable<PutResponse<any>> {
    return this.put(environment.coreApiUrl + 'events/registrations/service', payload, {raiseErrorToast: raiseErrorToast})
  }


  aqh_cls_0(payload: AQH_CLS_0, raiseErrorToast: boolean = true): Observable<GetResponse<ClassResponse[]>> {
    return this.get(environment.coreApiUrl + 'classes/', payload, {raiseErrorToast: raiseErrorToast})
  }



  aqg_cls_0(payload: AQH_CLS_0, raiseErrorToast: boolean = true): Observable<GetResponse<ClassResponse[]>> {
    return this.get(environment.coreApiUrl + 'classes/', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_sta_0(payload: AQH_STA_0, raiseErrorToast: boolean = true): Observable<GetResponse<HorseRegistryResponse[]>> {
    return this.get(environment.coreApiUrl + 'static/horse-registries', payload, {raiseErrorToast: raiseErrorToast})
  }

  aqh_sta_1(payload: AQH_STA_1, raiseErrorToast: boolean = true): Observable<GetResponse<MembershipPlanResponse[]>> {
    return this.get(environment.coreApiUrl + 'static/membership-plans', payload, {raiseErrorToast: raiseErrorToast})
  }
}

